module.exports = __webpack_public_path__ + "img/web_layout_svgs.ff38a9ae.svg";